import { useContext, useEffect, useState } from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';

import { Routes } from 'types/routes';

import Logo from 'theme/images/logo.svg';

import LocaleContext from 'components/context/Locale';
import Head from 'components/layout/Head';
import LayoutDefault from 'components/modules/public/layouts/Default';

import SectionRegister from './sections/Register';
import SectionRegisterFirstStep from './sections/RegisterFirstStep';
import { Props } from './index';
import StyledComponent from './styles';

const PublicPageRegisterEmployee: NextPage<Props> = ({ state }) => {
    const router = useRouter();

    const localeContext = useContext(LocaleContext);
    const data = localeContext?.translations?.registerEmployee;
    const [phoneForm, setPhoneForm]: [boolean, Function] = useState(false);
    const [emailForm, setEmailForm]: [boolean, Function] = useState(false);
    const [nextStep, setNextStep]: [boolean, Function] = useState(false);

    useEffect(() => {
        if (state.profile) {
            if (state.profile.isActive === false) router.push(Routes.PublicActivationAccount);
            else router.push(Routes.PublicHome);
        }
    }, [state.profile]);


    return (
        <StyledComponent className="public-page-register-employee">
            <Head {...data.meta} />
            <LayoutDefault>
                <div className="header-mobile">
                    <a href={Routes.PublicHome}>
                        <img
                            className="logo"
                            src={Logo}
                            loading="lazy"
                        />
                    </a>
                </div>
                {!nextStep && (
                    <SectionRegisterFirstStep
                        {...data?.content?.firstStep}
                        setPhoneForm={setPhoneForm}
                        setEmailForm={setEmailForm}
                        setNextStep={setNextStep}
                    />
                )}
                {nextStep && (
                    <SectionRegister
                        {...data?.content?.register}
                        phoneForm={phoneForm}
                        emailForm={emailForm}
                    />
                )}
            </LayoutDefault>
        </StyledComponent>
    );
};

export default PublicPageRegisterEmployee;
